import SvgIcon, { type SvgIconProps } from 'LuxKit/SvgIcon'

function WeddingQuoteOpenIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 40 32">
      <path fill="currentColor" d="M7.36 16.7324C11.4133 16.839 14.8267 19.7165 14.8267 23.9796C14.8267 28.0295 11.6267 31.3333 7.36 31.3333C2.77333 31.3333 0 27.9229 0 23.0204C0 13.9615 8.96 3.83673 18.3467 0L19.0933 1.17233C13.6533 4.36962 7.46667 10.1247 7.36 16.7324ZM28.2667 16.7324C32.32 16.839 35.7333 19.7165 35.7333 23.9796C35.7333 28.0295 32.5333 31.3333 28.2667 31.3333C23.68 31.3333 20.9067 27.9229 20.9067 23.0204C20.9067 13.9615 29.8667 3.83673 39.2533 0L40 1.17233C34.56 4.36962 28.3733 10.1247 28.2667 16.7324Z" />
    </SvgIcon>
  )
}
export default WeddingQuoteOpenIcon
